import './assets/style.css';const modalCell = "_modalCell_1k96p_1";
const withoutBorder = "_withoutBorder_1k96p_8";
const label = "_label_1k96p_12";
const asterisk = "_asterisk_1k96p_22";
const criticalSection = "_criticalSection_1k96p_27";
const criticalIcon = "_criticalIcon_1k96p_42";
const clearButton = "_clearButton_1k96p_46";
const caption = "_caption_1k96p_50";
const suggestSection = "_suggestSection_1k96p_62";
const twinContainer = "_twinContainer_1k96p_68";
const textAreaContainer = "_textAreaContainer_1k96p_74";
const modalTextArea = "_modalTextArea_1k96p_81";
const criticalSectionMultiline = "_criticalSectionMultiline_1k96p_87";
const wordCount = "_wordCount_1k96p_103";
const s = {
  modalCell,
  withoutBorder,
  label,
  asterisk,
  criticalSection,
  criticalIcon,
  clearButton,
  caption,
  suggestSection,
  twinContainer,
  textAreaContainer,
  modalTextArea,
  criticalSectionMultiline,
  wordCount
};
export {
  s
};
